// CEO.js
import { useTranslation } from "react-i18next";
import Seo from "../../components/Seo/Seo";
import "./CEO.css";

export default function CEO() {
  const { t } = useTranslation("common");

  return (
    <>
      <Seo
        title={t("ceo.seo.title")}
        description={t("ceo.seo.description")}
        path="/ceo"
      />

      {/* Hero Section */}
      <section className="ceoHero">
        <div className="ceoHero__overlay"></div>
        <div className="container">
          <h1 className="ceoHero__title">{t("ceo.hero.title")}</h1>
          <p className="ceoHero__subtitle">{t("ceo.hero.subtitle")}</p>
        </div>
      </section>

      {/* Profile Section */}
      <section className="ceoProfile">
        <div className="container">
          <div className="ceoProfile__content">
            {/* CEO Image */}
            <div className="ceoProfile__imageWrapper">
              <div className="ceoProfile__imageBorder">
                <div className="ceoProfile__image">
                  {/* Placeholder - Replace with actual image later */}
                  <div className="ceoProfile__image">
                    <img
                      src="https://res.cloudinary.com/dxgqcmf7j/image/upload/v1766480089/wdorjbls6veuzfjuxxxq.svg"
                      alt={t("ceo.profile.name")}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* CEO Info */}
            <div className="ceoProfile__info">
              <h2 className="ceoProfile__name">{t("ceo.profile.name")}</h2>
              <p className="ceoProfile__title">{t("ceo.profile.position")}</p>

              <div className="ceoProfile__bio">
                <p>{t("ceo.profile.bio")}</p>
              </div>

              {/* Stats */}
              <div className="ceoProfile__stats">
                <div className="ceoProfile__stat">
                  <div className="ceoProfile__statNumber">{t("ceo.profile.stats.experience.number")}</div>
                  <div className="ceoProfile__statLabel">{t("ceo.profile.stats.experience.label")}</div>
                </div>
                <div className="ceoProfile__stat">
                  <div className="ceoProfile__statNumber">{t("ceo.profile.stats.projects.number")}</div>
                  <div className="ceoProfile__statLabel">{t("ceo.profile.stats.projects.label")}</div>
                </div>
                <div className="ceoProfile__stat">
                  <div className="ceoProfile__statNumber">{t("ceo.profile.stats.achievements.number")}</div>
                  <div className="ceoProfile__statLabel">{t("ceo.profile.stats.achievements.label")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Message Section */}
      <section className="ceoVision">
        <div className="container">
          <div className="ceoVision__grid">
            {/* Vision Card */}
            <div className="ceoVision__card">
              <div className="ceoVision__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </div>
              <h3 className="ceoVision__cardTitle">{t("ceo.vision.title")}</h3>
              <p className="ceoVision__cardText">{t("ceo.vision.content")}</p>
            </div>

            {/* Message Card */}
            <div className="ceoVision__card">
              <div className="ceoVision__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
              <h3 className="ceoVision__cardTitle">{t("ceo.message.title")}</h3>
              <p className="ceoVision__cardText">{t("ceo.message.content")}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="ceoAchievements">
        <div className="container">
          <h2 className="ceoAchievements__title">{t("ceo.achievements.title")}</h2>
          <div className="ceoAchievements__grid">
            {[1, 2, 3, 4].map((num) => (
              <div key={num} className="ceoAchievements__item">
                <div className="ceoAchievements__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                </div>
                <h4>{t(`ceo.achievements.items.${num}.title`)}</h4>
                <p>{t(`ceo.achievements.items.${num}.description`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}